import { createI18n } from "vue-i18n";
// import enUS from "./locales/en-US";
// import zhCN from "./locales/zh-CN";
import enUS from "./locales/TXT_en.json";
import zhCN from "./locales/TXT_zh-CN.json";
import zh from "./locales/TXT_zh.json";

// 获取保存的语言设置，默认为中文
function getStoredLocale(): string {
  if (typeof window !== "undefined") {
    return localStorage.getItem("wlink-locale") || "en";
  }
  return "en";
}

// 创建i18n实例
export function createWlinkI18n() {
  return createI18n({
    legacy: false,
    locale: getStoredLocale(),
    fallbackLocale: "en",
    messages: {
      "zh-CN": zhCN,
      "zh-TW": zh,
      en: enUS,
    },
  });
}

// 导出语言包
export { enUS, zh, zhCN };

// 导出类型
export type { Locale } from "vue-i18n";
